/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('CourseCtrl', function(
    $scope,
    $location,
    $routeParams,
    $window,
    Activity,
    identity,
    courses,
    course,
    Stats,
    module,
    modules_url,
    intraprof_web_url
) {
    $scope.me              = identity;
    $scope.courses         = courses;
    $scope.modules_url     = modules_url;
    $scope.uv_name         = module.uv_name;
    $scope.selected_course = false;
    $scope.selected_lesson = false;
    $scope.stats           = [];

    Stats
    .getViewStatus({
        session_id: $routeParams.session_id,
        student_id: $scope.me.id}).$promise
    .then(function(stats) {
        $scope.stats = stats;
        return (() => {
            const result = [];
            for (var activity of Array.from($scope.courses)) {
                activity.view = 0;
                result.push((() => {
                    const result1 = [];
                    for (let value of Array.from($scope.stats)) {
                        if ((value.path != null) && (value.path.indexOf(activity.name) !== -1)) {
                            activity.view = 1;
                            break;
                        } else {
                            result1.push(undefined);
                        }
                    }
                    return result1;
                })());
            }
            return result;
        })();
    });

    $scope.selectLesson = lesson => $scope.selected_lesson = `${modules_url}${lesson}`;


    $scope.selectCourse = function(course) {
        $scope.selected_course = course;
        $scope.params          = {
            module_id:   $routeParams.session_id,
            activity_id: course.id
        };
        Activity
        .files({
            session_id:    $routeParams.session_id,
            activity_type: 'cours',
            activity_id:   course.id}).$promise
        .then(function(files) {
            files = files.map(function(file) {
                file.path = encodeURI(file.path);
                return file;
            });
            $scope.repositories = {
                'Video': [],
                'Sujet': [],
                'Autre fichier': []
            };
            for (let file of Array.from(files)) {
                switch (true) {
                    case /^video/i.test(file['mime/type']):
                        $scope.repositories['Video'].push(file);
                        break;
                    case /^text\/html/i.test(file['mime/type']):
                        $scope.repositories['Sujet'].push(file);
                        break;
                    default:
                        $scope.repositories['Autre fichier'].push(file);
                }
            }
            if (($scope.repositories.Video != null) && $scope.repositories.Video.length) {
                return $scope.selectLesson($scope.repositories.Video[0].path);
            } else {
                return $scope.selected_lesson = false;
            }
        });
        return $location.search('current_course', course.id);
    };

    // Lors d'un refresh de la page on prend en compte le ui-select
    if ($location.search().current_course != null) {
        $scope.courses.forEach(function(activity) {
            if (`${activity.id}` === $location.search().current_course) { return $scope.selectCourse(activity); }
        });
        if (!$scope.selected_course) { $scope.selectCourse($scope.courses[0]); }
    } else {
        $scope.selectCourse(course);
    }

    $scope.getIconView = function(view) {
        if (0 === view) { return 'fa fa-eye'; } else { return 'fa fa-check'; }
    };

    return $scope.download = filename => Activity.download({
        session_id:    $routeParams.session_id,
        activity_type: 'cours',
        activity_id:   $scope.selected_course.id,
        name:          filename
    });
});
